import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaBancosRecibosListaItemComponent {
  data
  onChange

  selecionar () {
    this.data.seleccionado = !this.data.seleccionado
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('nominasNominaBancosRecibosListaItem', {
  controller: NominasNominaBancosRecibosListaItemComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/recibos/lista/item/component.js